import { connect } from 'react-redux';
import { RankingPageType } from '../../../../../../domain/constants/GlobalNavigation';
import { IRankingState } from '../../../../common/store/ranking/ranking';
import Component, { IRankingProps as IProps } from '../../components/js/ranking/Ranking';
import { IGlobalNavigationState } from '../../store/globalNavigation';
import { IPageDataState } from '../../store/pageData';

interface OwnProps {
  yadsDs?: string;
}
interface State {
  globalNavigation: IGlobalNavigationState;
  textnewsRanking?: IRankingState;
  pageData: IPageDataState;
}

const mapStateToProps = (state: State, ownProps?: OwnProps): IProps => {
  if (!state.textnewsRanking?.list || state.textnewsRanking.list.length === 0) {
    return { isError: true, ultSec: '', categoryId: '' };
  }
  return {
    title: state.textnewsRanking.title,
    url: state.textnewsRanking.url,
    list: state.textnewsRanking.list,
    isError: false,
    ultSec: 'accr',
    yadsDs:
      ownProps?.yadsDs ??
      (state.globalNavigation.currentRanking && state.globalNavigation.currentRanking === RankingPageType.COMMENT
        ? undefined
        : '90113_218124'),
    shannonId: state.pageData.yads.shannonId,
    categoryId: state.pageData.yads.categoryId
  };
};

export default connect(mapStateToProps)(Component);
